import React from "react";
import classNames from "classnames";
import BaseRow from "../BaseRow";

export default class ChannelsRow extends BaseRow {
	generateChannelsOfTarifs() {
		let classes = this.props.classes;
		return this.props.data.map((item, index) => {
			let channels = "";
			if (item.tv) {
				if (item.tv.channels) {
					channels = `${item.tv.channels}`;
				}
				if (item.tv.channels_hd) {
					channels = !!channels.length
						? `${channels} + ${item.tv.channels_hd} HD`
						: `${item.tv.channels_hd} HD`;
				}
				if (!channels.length) {
					channels = "-";
				}
			}

			const withoutPointer = !!item.tv && !!item.tv.use_text;

			let high = null;
			if (this.props.maxChannelsTvTariff && channels != "-") {
				high = item.id == this.props.maxChannelsTvTariff.id ? this.generateHigherSvg() : null;
			}

			return (
				<div key={index} className={classes.cell}>
					<div className={classes.cellText}>
						{channels !== "-" && (
							<span
								className={classNames(classes.cellTextValuePurple, {
									[classes.withoutPointer]: withoutPointer,
								})}
								onClick={() => this.props.onClickHandler(item.id)}
							>
								{channels}
							</span>
						)}
						{channels === "-" && <span className={classes.cellTextValue}>{channels}</span>}
						{high}
					</div>
				</div>
			);
		});
	}

	render() {
		let classes = this.props.classes;
		let columns = {
			2: [classes.rowColNumber2],
			3: [classes.rowColNumber3],
			4: [classes.rowColNumber4],
			5: [classes.rowColNumber5],
			6: [classes.rowColNumber6],
		};
		let style = {
			transform: `translateX(${this.props.moveValue}px)`,
		};

		return (
			<div className={classNames(classes.row, columns[this.props.columns])}>
				<div className={classes.headerCell} style={style}>
					<div className={classes.headerCellText}>{this.props.header}</div>
				</div>
				<div className={classes.cellsWrapper}>{this.generateChannelsOfTarifs()}</div>
			</div>
		);
	}
}
